import { findLast } from 'lodash';

import { GUARANTOR_DOCS_DESCRIPTIONS, USERS_TYPES } from '../constants';
import { IGuarantor } from '../ts/guarantor';

export const areGuarantorDocumentsUploaded = (
  guarantor: IGuarantor,
  areIdentityDocumentsAlreadyUploaded: boolean,
): boolean => {
  const guarantorDocuments = guarantor.documents;
  const identityDocument = findLast(guarantorDocuments, {
    type: 'identity_document',
  });
  const taxNumber = findLast(guarantorDocuments, {
    type: 'tax_number',
  });
  const thirdLastPaycheck = findLast(guarantorDocuments, {
    type: 'proof_of_income',
    description: GUARANTOR_DOCS_DESCRIPTIONS.THIRD_LAST_PAYCHECK,
  });
  const secondLastPaycheck = findLast(guarantorDocuments, {
    type: 'proof_of_income',
    description: GUARANTOR_DOCS_DESCRIPTIONS.SECOND_LAST_PAYCHECK,
  });
  const lastPaycheck = findLast(guarantorDocuments, {
    type: 'proof_of_income',
    description: GUARANTOR_DOCS_DESCRIPTIONS.LAST_PAYCHECK,
  });
  const workContract = findLast(guarantorDocuments, {
    type: 'proof_of_income',
    description: GUARANTOR_DOCS_DESCRIPTIONS.WORK_CONTRACT,
  });
  const secondLastIncomeTaxReturn = findLast(guarantorDocuments, {
    type: 'proof_of_income',
    description: GUARANTOR_DOCS_DESCRIPTIONS.SECOND_LAST_INCOME_TAX_RETURN,
  });
  const lastIncomeTaxReturn = findLast(guarantorDocuments, {
    type: 'proof_of_income',
    description: GUARANTOR_DOCS_DESCRIPTIONS.LAST_INCOME_TAX_RETURN,
  });
  const banckAccountBalance = findLast(guarantorDocuments, {
    type: 'proof_of_income',
    description: GUARANTOR_DOCS_DESCRIPTIONS.BANK_ACCOUNT_BALANCE,
  });
  const universityCertification = findLast(guarantorDocuments, {
    type: 'other',
    description: GUARANTOR_DOCS_DESCRIPTIONS.UNIVERSITY_CERTIFICATION,
  });
  const lastPension = guarantorDocuments
    ? findLast(guarantorDocuments, {
        type: 'proof_of_income',
        description: GUARANTOR_DOCS_DESCRIPTIONS.LAST_PENSION_SLIPS,
      })
    : undefined;
  const secondLastPension = guarantorDocuments
    ? findLast(guarantorDocuments, {
        type: 'proof_of_income',
        description: GUARANTOR_DOCS_DESCRIPTIONS.SECOND_LAST_PENSION_SLIPS,
      })
    : undefined;
  const bankAccountBalancePenultimate = findLast(guarantorDocuments, {
    type: 'proof_of_income',
    description: GUARANTOR_DOCS_DESCRIPTIONS.PENULTIMATE_ACCOUNT_STATEMENT,
  });
  const bankAccountBalancePrePenultimate = findLast(guarantorDocuments, {
    type: 'proof_of_income',
    description: GUARANTOR_DOCS_DESCRIPTIONS.PREPENULTIMATE_ACCOUNT_STATEMENT,
  });
  const areAllDocumentsUploaded = () => {
    const areIdentityDocumentsUploaded =
      (identityDocument?.document_front &&
        identityDocument.document_rear &&
        taxNumber) ||
      areIdentityDocumentsAlreadyUploaded;

    if (guarantor?.occupation === USERS_TYPES.ITALIAN_STUDENT)
      return (
        areIdentityDocumentsUploaded &&
        universityCertification &&
        workContract &&
        lastPaycheck &&
        secondLastPaycheck &&
        thirdLastPaycheck
      );
    if (guarantor?.occupation === USERS_TYPES.FOREIGN_STUDENT)
      return universityCertification && banckAccountBalance;
    if (guarantor?.occupation === USERS_TYPES.SELF_EMPLOYED)
      return (
        areIdentityDocumentsUploaded &&
        banckAccountBalance &&
        lastIncomeTaxReturn &&
        bankAccountBalancePenultimate &&
        bankAccountBalancePrePenultimate &&
        secondLastIncomeTaxReturn &&
        taxNumber
      );
    if (guarantor?.occupation === USERS_TYPES.EMPLOYEE)
      return (
        areIdentityDocumentsUploaded &&
        workContract &&
        lastPaycheck &&
        secondLastPaycheck &&
        thirdLastPaycheck &&
        taxNumber
      );
    if (
      guarantor?.occupation === USERS_TYPES.PENSIONER ||
      guarantor?.occupation === USERS_TYPES.RETIRED
    )
      return (
        areIdentityDocumentsUploaded &&
        lastPension &&
        secondLastPension &&
        taxNumber
      );
  };
  return areAllDocumentsUploaded() as boolean;
};
